<!--
 * @Description: 任务过期
 * @Date: 2024-04-30 15:44:27
-->
<template>
  <el-dialog
    title="提示"
    width="500px"
    :close-on-click-modal="false"
    :visible="true"
    :before-close="close"
  >
    <div v-if="isChannelAndNotNext" style="margin:20px 0">
      <span>选择过期时间：</span>
      <el-date-picker
        v-model="taskOverdueDate"
        type="daterange"
        range-separator="至"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        :clearable="true"
        :start-placeholder="'开始日期'"
        :end-placeholder="'结束日期'"
      ></el-date-picker>
    </div>
    <div v-html="content"></div>
    <div class="footer">
      <el-button @click="close" plain>取消</el-button>
      <el-button v-if="isChannelAndNotNext" @click="confirm" type="primary">
        确认
      </el-button>
      <el-button v-else @click="confirm" :disabled="time > 0" type="primary">
        确认过期{{ time > 0 ? `(${time}s)` : '' }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryChannelUvTask } from '@R/api';
import createExtend from '@C/createExtend';
import taskOverdueMsg from '@/page/project-record/components/task-overdue-msg.vue';

export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    projectType: {
      type: [String, Number],
      default: ''
    },
    projectId: {
      type: [String, Number],
      default: ''
    },
    source: {
      type: Number,
      default: null
    },
    taskId: {
      type: [String, Number],
      default: ''
    },
    isNext: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      time: 3,
      timer: null,
      taskOverdueDate: []
    };
  },
  computed: {
    isChannelAndNotNext() {
      return +this.projectType === 6 && !this.isNext;
    }
  },
  methods: {
    confirm() {
      if (this.isChannelAndNotNext) {
        if (this.taskOverdueDate.length === 0) {
          this.$message.error('请选择过期时间');
          return;
        }
        queryChannelUvTask({
          startDt: this.taskOverdueDate[0],
          endDt: this.taskOverdueDate[1],
          projectId: this.projectId,
          source: this.source,
          taskId: this.taskId
        }).then(res => {
          const { redisKeyUv, size } = res.pdata;
          if (!size) {
            this.$message.error(
              '当前选择时间段内没有可过期任务，请重新选择过期时间'
            );
          } else {
            const content = `<p>你正在操作任务过期，本次过期任务数 <span style='color:#027cfa'>${size}</span> 条，请谨慎处理，任务过期后将无法恢复</p>`;
            const nextOverDue = createExtend(taskOverdueMsg, {
              content,
              isNext: true,
              projectType: this.projectType,
              projectId: this.projectId,
              source: this.source,
              taskId: this.taskId
            });
            nextOverDue.$on('confirm', () => {
              this.$emit('confirm', redisKeyUv);
              nextOverDue.remove();
              this.close();
            });
          }
        });
        return;
      }
      this.$emit('confirm', this.taskOverdueDate);
    },
    close() {
      this.$emit('close');
    }
  },
  created() {
    // 倒计时3s后才允许操作
    this.timer = setInterval(() => {
      this.time--;
      if (this.time === 0) {
        clearInterval(this.timer);
      }
    }, 1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="scss" scoped>
.reject {
  width: 700px;
  &__content {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
.select-area {
  text-align: left;
  .select-text {
    margin-top: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    display: flex;
    justify-content: space-between;
  }
  .select-text:hover {
    background-color: #fff;
    cursor: pointer;
  }
  width: 280px;
  padding: 20px;
  height: 199px;
  background: #f5f7fa;
  border-radius: 2px;
  opacity: 0.99;
}
.footer {
  text-align: right;
  margin-top: 30px;
}
</style>
